// extracted by mini-css-extract-plugin
export default {"pressReleases":"PressReleases_pressReleases__HW2-4","pressRelease":"PressReleases_pressRelease__pm5w+"};